<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getDetails,
  exportDetails,
} from "@/api/branch/bill";
import {
	hangDetails,
	deleteBillDetails
} from "@/api/finance/bill_hq";
import { getExpense } from "@/api/finance/expense";
import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";

export default {
  components: {
    cTable,
  },
  props: {
    rowObj: {
      type: Object,
    },
  },
  data() {
    return {
      config: {
        slot: "div",
        rows: this.rowObj,
      },
      methods: {
        list: (p) => {
          p.id = this.config.rows.financeInfo.id;
          return getDetails(p);
        },
        exportDetails,
        hangDetails,
        deleteBillDetails,
        getExpense,
        getCountry,
        // beforeHandleList: ({ data }) => {
        //   this.totalAmount = data.totalAmount;
        // }
      },
      totalAmount: "",
      modals: {
        hang: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.ids = this.$page.selectAll.map((item) => item.id);
              data.id = this.$page.config.rows.id;
              this.$page
                .handleRequestMethods("hangDetails", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 80,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
      },
      footer: {
        show: () => true,
        // render: h => {
        //   return h(
        //     "div",
        //     {
        //       class: "footer-div"
        //     },
        //     [
        //       h("span", "合计CNY:"),
        //       h(
        //         "span",
        //         {
        //           style: {
        //             color: "red"
        //           }
        //         },
        //         this.totalAmount
        //       )
        //     ]
        //   );
        // }
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "to_country",
            placeholder() {
              return this.$t("select") + this.$t("countryName");
            },
            component: "Select",
            options: [],
            config: { label: "code", value: "code" },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: this.$t("hang"),
              type: "hang",
              fnName: "hang",
              bind: {
                icon: "md-trash",
                type: "error",
              },
              disabled() {
                return (
                  !this.selectAll.length ||
                  this.config.rows.financeInfo.status != "WAIT_CONFIRM"
                );
              },
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                icon: "md-trash",
                type: "error",
              },
              disabled() {
                return (
                  !this.selectAll.length ||
                  this.config.rows.financeInfo.status != "WAIT_CONFIRM"
                );
              },
            },
          ],
          methods: {
            export() {
              this.handleRequestMethods(
                "exportDetails",
                this.config.rows.financeInfo.id
              ).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                window.open(this.$globalUrl + res.payload);
              });
            },
            hang() {
              this.getModal("hang").open({}, function () {
                this.setTitle(this.$t("hang"));
              });
            },
            delete() {
							console.log(this.config.rows);
							return;
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let data = {
                    id: this.config.rows.id,
                    ids: this.selectAll.map((item) => {
                      return item.id;
                    }),
                  };
                  this.handleRequestMethods("deleteBillDetails", data).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          minWidth: 120,
        },
        {
          name: () => this.$t("clientName"),
          key: "client_account",
          minWidth: 100,
        },
        {
          name: () => this.$t("type"),
          key: "type",
          minWidth: 110,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          minWidth: 130,
        },
        {
          name: () => this.$t("countryName"),
          key: "to_country",
          minWidth: 100,
        },
        {
          name: () => this.$t("channel_code"),
          key: "transport_mode",
          minWidth: 100,
        },
        {
          name: () => this.$t("charge_volume"),
          key: "charge_volume",
          minWidth: 100,
        },
        {
          name: () => this.$t("charge_params"),
          key: "charge_params",
          minWidth: 100,
        },
        {
          name: () => this.$t("values"),
          key: "values",
          minWidth: 100,
        },
        {
          name: () => this.$t("rate"),
          key: "rate",
          minWidth: 115,
          children: [
            {
              name: () => this.$t("freight_fees"),
              key: "freight_unit_to_cny_rate",
              minWidth: 120,
            },
            {
              name: () => this.$t("taxFee"),
              key: "tax_currency_to_cny_rate",
              minWidth: 120,
            },
          ],
        },
        {
          name: () => this.$t("OriginalCurrency"),
          minWidth: 120,
          children: [
            {
              name: () => this.$t("freight_fees"),
              key: "freight_fees",
              minWidth: 120,
            },
            {
              name: () => this.$t("express_currency"),
              key: "freight_unit",
              minWidth: 120,
            },
            {
              name: () => this.$t("total_tax"),
              key: "total_tax",
              minWidth: 120,
            },
            {
              name: () => this.$t("taxCurrency"),
              key: "tax_currency",
              minWidth: 120,
            },
            {
              name: () => this.$t("vat_fee"),
              key: "vat_fee",
              minWidth: 130,
            },
            {
              name: () => this.$t("tax_fee"),
              key: "tax_fee",
              minWidth: 120,
            },
            {
              name: () => this.$t("document_fee"),
              key: "document_fee",
              minWidth: 130,
            },
          ],
        },
        {
          name: () => "CNY",
          minWidth: 120,
          children: [
            {
              name: () => this.$t("freight_fees"),
              key: "freight_fees_cny",
              minWidth: 120,
            },
            {
              name: () => this.$t("total_tax"),
              key: "total_tax_cny",
              minWidth: 120,
            },
            {
              name: () => this.$t("vat_fee"),
              key: "vat_fee_cny",
              minWidth: 130,
            },
            {
              name: () => this.$t("tax_fee"),
              key: "tax_fee_cny",
              minWidth: 120,
            },
            {
              name: () => this.$t("document_fee"),
              key: "document_fee_cny",
              minWidth: 130,
            },
          ],
        },
        {
          name: () => this.$t("otherCost"),
          minWidth: 120,
          children: [
            {
              name: () => this.$t("overload_fee"),
              key: "ext_material_fee",
              minWidth: 80,
            },
            {
              name: () => this.$t("extra_charge"),
              key: "ext_op_fee",
              minWidth: 80,
            },
            {
              name: () => this.$t("overload_fee"),
              key: "ext_overload_fee",
              minWidth: 80,
            },
            {
              name: () => this.$t("overweight_fee"),
              key: "ext_overweight_fee",
              minWidth: 80,
            },
            {
              name: () => this.$t("remote_fee"),
              key: "remote_fee",
              minWidth: 80,
            },
          ],
        },
        {
          name: () => this.$t("freight_append"),
          key: "freight_append",
          minWidth: 120,
          fixed: "right",
        },
      ],
    };
  },
  async mounted() {
    let data = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
    this.header.searchs.forEach((item) => {
      if (item.key === "to_country") item.options = data;
    });
  },
};
</script>
